/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CdvxStats { 
    available_space?: number;
    data_reduction_ratio: number;
    logical_used_size: number;
    usable_space?: number;
    used_space: number;
}

